
import { useState, useEffect, useRef } from "react";

const videos = [
  { id: "UOUQHcQrTug?si=OvxybccDfEVEV6Bb", title: "#StoriesOfMG | MG Gloster | Major Jaideep Singh (Retd.)" },
  { id: "utfKw4boZso?si=WkgJz3CMT8vxbXYd", title: "#StoriesOfMG | MG Gloster | Vyasraj and Jyoti" },
  { id: "Cl7O4R2NLFo?si=syFy8coejlm2PI7I", title: "#StoriesOfMG | MG Gloster | Gaurav Madan" },
  { id: "nJhjcWyJ0gc?si=L7bEooBM_6GYymBS", title: "#StoriesOfMG | MG Gloster | Praveen Nune" },
  { id: "A2odrdlv_bI?si=v0uLR8d5TSk7YKZZ", title: "#StoriesOfMG | MG Gloster | Ravi Bali" },
  { id: "JAHtS-Fn7U8?si=fc0_80MPj5PyawE6", title: "#StoriesOfMG | MG Gloster | Naveen Malik" },
];

const css = `
  .mg-section {
    font-family: 'Georgia', serif;
    background: #fff;
    padding: 60px 0 80px;
    overflow: hidden;
  }

  .mg-heading {
    text-align: center;
    color: #c0001d;
    font-size: 2.1rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    margin-bottom: 48px;
    font-family: 'Georgia', serif;
    padding: 0 16px;
  }

  .mg-wrapper {
    position: relative;
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .mg-overflow {
    overflow: hidden;
  }

  .mg-track {
    display: flex;
    gap: 20px;
    transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    will-change: transform;
  }

  /* Desktop: 2 cards visible */
  .mg-card {
    min-width: calc(50% - 10px);
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: 0 2px 12px rgba(0,0,0,0.07);
    transition: box-shadow 0.3s, transform 0.3s;
  }

  .mg-card:hover {
    box-shadow: 0 8px 32px rgba(192,0,29,0.12);
    transform: translateY(-3px);
  }

  .mg-iframe-wrap {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    background: #000;
  }

  .mg-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  .mg-card-title {
    padding: 14px 8px 10px;
    font-size: 0.95rem;
    color: #222;
    font-weight: 600;
    font-family: 'Arial', sans-serif;
    line-height: 1.4;
  }

  /* Nav row */
  .mg-nav-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 36px;
  }

  .mg-nav-btn {
    width: 46px;
    height: 46px;
    border-radius: 20%;
    background: #c0001d;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1;
    transition: background 0.2s, transform 0.15s, opacity 0.2s;
    flex-shrink: 0;
  }

  .mg-nav-btn:not(:disabled):hover {
    background: #a00018;
    transform: scale(1.08);
  }

  .mg-nav-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Dots */
  .mg-dots {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .mg-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ddd;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
  }

  .mg-dot.active {
    background: #c0001d;
    transform: scale(1.3);
  }

  /* ── Tablet: ≤ 900px — show 2 cards but tighter ── */
  @media (max-width: 900px) {
    .mg-heading { font-size: 1.7rem; margin-bottom: 36px; }
    .mg-wrapper { padding: 0 14px; }
    .mg-card-title { font-size: 0.88rem; }
  }

  /* ── Mobile: ≤ 640px — show 1 card at a time ── */
  @media (max-width: 640px) {
    .mg-section { padding: 36px 0 56px; }
    .mg-heading { font-size: 1.35rem; margin-bottom: 28px; }
    .mg-wrapper { padding: 0 12px; }

    /* 1 card: full width */
    .mg-card { min-width: 100%; }

    .mg-track { gap: 12px; }

    .mg-nav-btn { width: 40px; height: 40px; font-size: 1.2rem; }
    .mg-card-title { font-size: 0.84rem; padding: 10px 6px 8px; }
    .mg-nav-row { margin-top: 24px; gap: 10px; }
  }

  /* ── Small mobile: ≤ 380px ── */
  @media (max-width: 380px) {
    .mg-heading { font-size: 1.15rem; }
    .mg-card-title { font-size: 0.78rem; }
    .mg-nav-btn { width: 36px; height: 36px; font-size: 1.1rem; }
  }
`;

function useVisibleCount() {
  const [count, setCount] = useState(2);
  useEffect(() => {
    const update = () => setCount(window.innerWidth <= 640 ? 1 : 2);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return count;
}

export default function MGGlosterTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = useVisibleCount();
  const maxIndex = videos.length - visibleCount;

  // Reset index when visibleCount changes to avoid out-of-bounds
  useEffect(() => {
    setCurrentIndex((i) => Math.min(i, Math.max(0, videos.length - visibleCount)));
  }, [visibleCount]);

  const prev = () => setCurrentIndex((i) => Math.max(0, i - 1));
  const next = () => setCurrentIndex((i) => Math.min(maxIndex, i + 1));

  // translateX accounts for gap (20px desktop, 12px mobile)
  const gap = visibleCount === 1 ? 12 : 20;
  const cardWidthPct = 100 / visibleCount;
  const translateX = `calc(-${currentIndex} * (${cardWidthPct}% + ${gap}px))`;

  const totalDots = maxIndex + 1;

  return (
    <>
      <style>{css}</style>
      <div className="mg-section">
        <h2 className="mg-heading">Proud MG Gloster Owners</h2>

        <div className="mg-wrapper">
          <div className="mg-overflow">
            <div className="mg-track" style={{ transform: `translateX(${translateX})` }}>
              {videos.map((v, i) => (
                <div key={i} className="mg-card">
                  <div className="mg-iframe-wrap">
                    <iframe
                      src={`https://www.youtube.com/embed/${v.id}`}
                      title={v.title}
                      allowFullScreen
                      loading="lazy"
                    />
                  </div>
                  <div className="mg-card-title">{v.title}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="mg-nav-row">
            <button
              className="mg-nav-btn"
              onClick={prev}
              disabled={currentIndex === 0}
              aria-label="Previous"
            >
              ‹
            </button>

           

            <button
              className="mg-nav-btn"
              onClick={next}
              disabled={currentIndex >= maxIndex}
              aria-label="Next"
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </>
  );
}